export default function GroupsScreen() {
  return null;
}